import { render, staticRenderFns } from "./MedicineSettings.vue?vue&type=template&id=19b746b8"
import script from "./MedicineSettings.vue?vue&type=script&lang=js"
export * from "./MedicineSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports